import { useT } from "../../../core/i18n";
import React, { useState } from "react";
import { Tabs } from "antd";
import { Link } from "react-router-dom";
import CircularsTab from "./CircularsTab";
import FavouriteCircularsTab from "./FavouriteCircularsTab";
import EventsTab from "./EventsTab";
import NewslettersTab from "./NewslettersTab";
import TrainingTab from "./TrainingTab";
import { all_routes } from "../../router/all_routes";

const CircularsPage: React.FC = () => {
  const { t } = useT();
  const [activeTab, setActiveTab] = useState("1");
  const routes = all_routes;

  const tabs = [
    { key: "1", label: "Circulars" },
    { key: "2", label: "Favourite Circulars" },
    { key: "3", label: "Events" },
    { key: "4", label: "Newsletters" },
    { key: "5", label: "Training" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "1":
        return <CircularsTab />;
      case "2":
        return <FavouriteCircularsTab />;
      case "3":
        return <EventsTab />;
      case "4":
        return <NewslettersTab />;
      case "5":
        return <TrainingTab />;
      default:
        return <CircularsTab />;
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">{t("circulars_and_communications")}</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.employeeDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">{t("circulars")}</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Tabs */}
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          items={tabs.map((tab) => ({
            label: tab.label,
            key: tab.key,
          }))}
        />
        {renderTabContent()}
      </div>
    </div>
  );
};

export default CircularsPage;
